import React from "react";
import { Button } from "@astryxdesign/core";
import type { ButtonProps } from "@astryxdesign/core";
import styles from "./AuthSubmitButton.module.css";

export type AuthSubmitButtonProps = Omit<ButtonProps, "className" | "xstyle">;

/**
 * The signed-out screens' primary button: Astryx's `Button` filled with the
 * theme's ink. Takes the same props; MUST be rendered inside an `AuthLayout`.
 */
const AuthSubmitButton = (props: AuthSubmitButtonProps): React.ReactElement => {
  return <Button {...props} className={styles.submit} />;
};

export default AuthSubmitButton;
